export const config = {
  title: "DSM Pet Care Club",
  meta: {
    description:
      "DSM Pet Care Club offers insured and bonded pet care services in Des Moines & Ames, IA—including dog walking, pet sitting, vacation care, and pet taxi services tailored to your pet’s needs.",
    keywords: [
      "DSM Pet Care Club",
      "Des Moines pet sitting",
      "dog walking Ames IA",
      "pet taxi Des Moines",
      "Iowa professional pet care"
    ],
    author: "DSM Pet Care Club",
    canonicalUrl: "https://theclubdsm.com/",
  },
  sections: {
    header: { businessName: "DSM Pet Care Club" },
    sectionB: {
      heroTitle: "DSM Pet Care Club",
      heroSubtitle: "Trusted Dog Walking & Pet Sitting in Central Iowa",
      learnAboutText: "Book a Service",
      phoneNumber: "5159813443",
      phoneLabel: "(515) 981‑3443",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2192278403/photo/asian-woman-enjoying-a-sunny-day-outdoors-with-her-dog-in-a-park.jpg?s=612x612&w=0&k=20&c=MqXTLeuUx4DLxoijZEFlvOMKR3xAdqS26jAvpPxSeRs=",
      cardData: [
        {
          title: "Dog Walking",
          description: "Daily and weekend walks to keep pets active & happy.",
        },
        {
          title: "Pet Sitting",
          description: "Drop‑in visits and overnight stays in your home.",
        },
        {
          title: "Vacation Care & Pet Taxi",
          description: "In‑home vacation care and transportation to vet or groomer.",
        },
      ],
      description:
        "Operating in Des Moines, Ames, and surrounding areas, DSM Pet Care Club provides professional, personalized pet care—ensuring physical and emotional enrichment with every visit.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Tailored pet care solutions including pet taxi, walking, sitting and overnight stays.",
      cards: [
        {
          title: "Dog Walking & Exercise",
          description: "Experienced handlers take your pup on enriching walks.",
          imageSrc: "https://media.istockphoto.com/id/1445417524/photo/senior-couple-dog-walk-and-nature-park-road-during-exercise-walking-and-leisure-during-a.jpg?s=612x612&w=0&k=20&c=LTif-WvDBfWPOItveFQr6vnNzb0PWdq4w5s2Kr23YjA=",
          imageAlt: "Dog Walking",
        },
        {
          title: "Pet Sitting & Overnight Care",
          description:
            "Safe, insured in‑home visits for cats and dogs while you're away.",
          imageSrc: "https://media.istockphoto.com/id/2157570878/vector/pet-sitting-services-various-pets-at-home-overnight-house-sitter-domestic-animal-daycare.jpg?s=612x612&w=0&k=20&c=_wS35B-hH4EgQ-b9G7tzAHLLyybKglDDOPgjvL-yiV8=",
          imageAlt: "Pet Sitting",
        },
        {
          title: "Pet Taxi & In‑Home Vacation Care",
          description:
            "Transport to appointments or extended care tailored to pets' routines.",
          imageSrc: "https://media.istockphoto.com/id/1186670847/vector/car-travel-road-trip-with-a-pet-cat-and-dog.jpg?s=612x612&w=0&k=20&c=BW5CE5A_Wu2rORCmaIZwYm_BqIfKcU_F9CpJuSf3nuo=",
          imageAlt: "Pet Taxi",
        },
      ],
      otherServicesTitle: "Additional Offerings",
      otherServicesList: [
        "Meet & Greet Scheduling",
        "Customized Care Packages",
        "Insured and Bonded Sitters",
        "Last‑Minute Coverage"
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://thepetcare.club/wp-content/uploads/2025/04/The-Pet-Care-Club-Des-Moines-Logo-1-e1752590257552.png",
        alt: "DSM Pet Care Club Team",
      },
      aboutText: [
        "DSM Pet Care Club is proudly insured and bonded, serving Central Iowa with high standards of care and trust.",
        "Our team is trained and committed to delivering safe, enriching, and responsive care—whether for daily walks, overnight stays, or pet transportation.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "DSM Pet Care Club Logo",
      businessName: "DSM Pet Care Club",
      contact: {
        phone: "5159813443",
        phoneLabel: "(515) 981‑3443",
        email: "support@theclubdsm.com",
        website: "https://theclubdsm.com/",
        address: "Serving Des Moines & Ames, IA",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/people/DSM-Pet-Care-Club/61574830210786/",
        instagram: "https://www.instagram.com/dsmpetcareclub/",
        twitter: null,
        linkedin: null,
        youtube: null,
        tiktok: "https://www.tiktok.com/@dsm.pet.care.club"
      },
    },
    sectionF: {
      address: "Central Iowa (Des Moines & Ames area)",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3245.0!2d-93.620!3d41.600!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87ee9abf3f1f579f%3A0xabcd1234567890!2sDes+Moines%2C+IA!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus",
    },
  },
};

export default config;
